import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Add access token from localStorage as fallback for cross-origin cookie issues
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("cherish_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const uploadFile = async (file, kind = "reference_photo") => {
    const form = new FormData();
    form.append("file", file);
    form.append("kind", kind);
    const { data } = await api.post("/uploads", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
};

export const uploadFileUrl = (path) => `${API_BASE}/uploads/${path}`;

export const formatINR = (n) => {
    if (n == null || Number.isNaN(Number(n))) return "₹0";
    const v = Number(n);
    // Show paise only when the amount has a fractional part (e.g. miniature ₹12/gram pricing)
    return "₹" + v.toLocaleString("en-IN", Number.isInteger(v) ? {} : { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
